/**
 * GA4 Analytics helper — tracks conversion events via gtag.
 * Also fires Facebook Pixel events when fbq is available.
 * Only fires if gtag/fbq is loaded (production). Silent no-op otherwise.
 */
export const trackEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params);
  }
};

const trackFBEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params);
  }
};

// Pre-defined conversion events
export const analytics = {
  signup: (method = 'email') => {
    trackEvent('sign_up', { method });
    trackFBEvent('CompleteRegistration', { content_name: method });
  },

  login: (method = 'email') => trackEvent('login', { method }),

  listingCreated: (listingType, plan) => {
    trackEvent('listing_created', { listing_type: listingType, plan: plan || 'free' });
    trackFBEvent('Lead', { content_name: `${listingType}_listing`, content_category: listingType });
  },

  requestCreated: () => trackEvent('request_created'),

  purchase: (value, plan, listingType) => {
    const numValue = parseFloat(value) || 0;
    trackEvent('purchase', {
      currency: 'GBP',
      value: numValue,
      items: [{ item_name: `${listingType}_${plan}`, item_category: listingType }],
    });
    trackFBEvent('Purchase', {
      currency: 'GBP',
      value: numValue,
      content_name: `${listingType}_${plan}`,
      content_type: 'product',
    });
  },

  messageSent: () => trackEvent('message_sent'),

  reviewSubmitted: (rating) => trackEvent('review_submitted', { rating }),

  offerMade: (value) => trackEvent('offer_made', { currency: 'GBP', value: parseFloat(value) || 0 }),

  shareClicked: (method, listingType) => trackEvent('share', { method, content_type: listingType }),

  searchPerformed: (query) => trackEvent('search', { search_term: query }),
};
